import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIconProps } from '../useIconProps';

var Insurance = function Insurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M27.98 51.93a.811.811 0 01-.086-.005l-.209-.024a.809.809 0 01-.119-.024C7.879 46.3 6.028 18.408 5.856 12.873a1.611 1.611 0 01.46-1.181 1.66 1.66 0 011.2-.5c11.733.079 17.308-4.536 19.156-6.518l.072-.077a1.773 1.773 0 011.276-.524 1.835 1.835 0 011.309.585c1.847 1.982 7.421 6.573 19.155 6.518a1.647 1.647 0 011.2.5 1.608 1.608 0 01.461 1.18 59.182 59.182 0 01-.293 4.176.75.75 0 01-1.492-.154c.2-1.945.265-3.383.285-4.066-.051-.106-.1-.149-.152-.135-12.343.073-18.279-4.869-20.262-7A.328.328 0 0028 5.573a.236.236 0 00-.178.07c-2.032 2.18-7.979 7.1-20.312 7.049a.118.118 0 00-.118.047c.131 5.434 1.9 32.346 20.527 37.678 12.263-3.563 17.321-16.494 19.404-26.735a.75.75 0 111.47.3C46.619 34.67 41.279 48.191 28.184 51.9a.739.739 0 01-.204.03z M27.986 44.566a.808.808 0 01-.085-.005l-.143-.017a.7.7 0 01-.119-.023C14.127 40.692 12.789 21.594 12.657 17.8a1.445 1.445 0 01.408-1.06 1.585 1.585 0 011.069-.45c7.866 0 11.556-3.052 12.787-4.372a1.457 1.457 0 012.161-.011c1.23 1.321 4.986 4.372 12.786 4.372a1.485 1.485 0 011.068.45 1.437 1.437 0 01.409 1.061c-.02.574-.071 1.517-.2 2.747l-.721 4.728c-1.5 7.4-5.186 16.7-14.236 19.268a.752.752 0 01-.202.033zM14.131 17.794c.15 3.556 1.4 21.637 13.812 25.253 8.207-2.425 11.6-11.136 13.008-18.04l.709-4.656c.115-1.123.164-2.013.184-2.568H41.8c-8.392 0-12.457-3.388-13.818-4.849-1.327 1.471-5.394 4.86-13.784 4.86zm27.739-.761z"
  }));
};

Insurance.displayName = 'Insurance';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Insurance.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Insurance;